export enum EventMembershipTypes {
    speaker = 'speaker',
    participant = 'participant',
    tutor = 'tutor',
    organizer = 'organizer'
}